import { render, staticRenderFns } from "./IconsGenerator.vue?vue&type=template&id=08839ace&scoped=true&"
import script from "./IconsGenerator.vue?vue&type=script&lang=js&"
export * from "./IconsGenerator.vue?vue&type=script&lang=js&"
import style0 from "./IconsGenerator.vue?vue&type=style&index=0&id=08839ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08839ace",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
